
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Playground, Props } from 'docz'
import FormNotice from './form-notice'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "formnotice"
    }}>{`FormNotice`}</h1>
    <p><strong parentName="p">{`SUBCATEGORY:`}</strong>{` Forms`}</p>
    <hr />
    <h2 {...{
      "id": "notice"
    }}>{`Notice`}</h2>
    <h3 {...{
      "id": "description"
    }}>{`Description`}</h3>
    <p>{`For giving feedback to the user, notices only appear below an input following validation.`}</p>
    <Playground __position={1} __code={'<FormNotice text=\"Notice\" />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      FormNotice
    }} mdxType="Playground">
  <FormNotice text="Notice" mdxType="FormNotice" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "notice-inverse"
    }}>{`Notice (inverse)`}</h2>
    <h3 {...{
      "id": "description-1"
    }}>{`Description`}</h3>
    <p>{`For giving feedback to the user, notices only appear below an input following validation.`}</p>
    <Playground __position={3} __code={'<FormNotice inverse text=\"Notice\" />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      FormNotice
    }} style={{
      backgroundColor: "#333",
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
  <FormNotice inverse text="Notice" mdxType="FormNotice" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <Props of={FormNotice} mdxType="Props" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;